/* tslint:disable */
import * as React from 'react';
import styles from './info-text.scss';
import { DisplayTextWithLinks } from 'ui/common/display-text-with-links';

export enum InfoType {
Text,
Button
}
/**
* Describes how the Info text component is displayed.
* > Without define visible prop component does not appear.
*/
export interface InfoTextProps {
/**
* Define whether the content of component should be visible. Default is 'undefined'.
*/
visible?: boolean;
/**
* Define content of component. Default is 'undefined'.
*/
text?: string;
/**
* Define type of component. Default is 'undefined'.
*/
type?: InfoType;
/**
* Define wheteher the urls in the text should be clickable. Default is 'true'.
*/
linkify?: boolean;
/**
* Override styles.
*/
className?: string;
/**
* Override info icon.
*/
infoIcon?: any;
}

export const InfoText: React.SFC<InfoTextProps> = (props) => {
  const {
    visible,
    text,
    linkify = true,
    className,
    infoIcon
  } = props;

  const helpIcon = <svg viewBox="0 0 20 20" height="10px" width="12px">
      <path className={styles.tooltipArrow} d="M4,0H16L10,6Z" transform="translate(-4)"/>
      <path fill="#0f204b" d="M10,7.1623a5.806,5.806,0,1,0,5.806,5.806h0A5.808,5.808,0,0,0,10,7.1623Z" transform="translate(-4)"/>
      <rect fill="white" x="5.4185" y="15.9023" width="1.162" height="1.161"/>
      <path fill="white" d="M11.78,12.5633l-.521.53a1.977,1.977,0,0,0-.679,1.643H9.4185v-.29a2.337,2.337,0,0,1,.675-1.639l.72-.732a1.135,1.135,0,0,0,.343-.819,1.161,1.161,0,1,0-2.322,0H7.6775a2.3225,2.3225,0,0,1,4.645,0,1.848,1.848,0,0,1-.541,1.308Z" transform="translate(-4)"/>
    </svg>;

  const infoText = <DisplayTextWithLinks text={text} linkify={linkify}/>

  return visible ?
    <span className={`${styles.infoTextTrigger} ${className}`}>
      {infoIcon || helpIcon}
      <div className={`${styles.infoText} infotext`} >{infoText}</div>
    </span> : null

};

InfoText.displayName = 'InfoText';
